import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Stack, Tooltip, Typography } from "@mui/material";
import { Virtuoso } from "react-virtuoso";
import TrendIcon from "../../../../../assets/images/customDashboard/TrendIcon.svg";
import { useTranslation } from "react-i18next";
import localizationKeys from "../../../../i18n/localizationKeys";

export const AddLiveTrendGraphs = (props) => {
  const {
    existingLiveTrendGraphs,
    setIsOpenLiveTrendPage,
    setIsDrawerOpen,
    setEditingLiveTrendChart,
  } = props;
  const { t } = useTranslation();
  const maxNumberOfLiveTrendGraphs = 4;

  const onChartNameClick = (chart) => {
    setIsDrawerOpen(false);
    setEditingLiveTrendChart(chart);
    setIsOpenLiveTrendPage(true);
  };

  return (
    <>
      <Stack spacing={1} sx={{ height: "calc(100% - 200px)" }}>
        <Typography sx={{ color: "white" }}>{"Add up to 4 Graphs"}</Typography>
        {/* virtual scroll */}
        <Virtuoso
          style={{ height: "100%" }}
          data={existingLiveTrendGraphs}
          itemContent={(_, chart) => {
            return (
              <Box
                key={chart?.id}
                onClick={() => {
                  onChartNameClick(chart);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderRadius: "12px",
                  border: "1px solid rgba(40, 182, 199, 0.7)",
                  padding: "0 0 0 6px",
                  marginBottom: "8px",
                  height: "35px",
                  width: "100%",
                  cursor: "pointer",
                  color: "white",
                  opacity: 1,
                }}
              >
                <Box component={"div"} sx={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={TrendIcon}
                    style={{ height: "24px", width: "24px", color: "rgba(40, 199, 90, 0.7)" }}
                  />
                  <Tooltip title={chart.chartName} placement="left" sx={{ fontSize: "14px" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        marginLeft: "4px",
                        width: "250px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {chart.chartName}
                    </Typography>
                  </Tooltip>
                </Box>
              </Box>
            );
          }}
        />
      </Stack>
      {existingLiveTrendGraphs?.length < maxNumberOfLiveTrendGraphs && (<Button
        onClick={() => {
          setEditingLiveTrendChart(null);
          setIsDrawerOpen(false);
          setIsOpenLiveTrendPage(true);
        }}
      >
        {t(localizationKeys.DashboardMakeLiveTrendButtonText)}
      </Button>)}
    </>
  );
};

AddLiveTrendGraphs.propTypes = {
  setSelectedDashboard: PropTypes.func,
  existingLiveTrendGraphs: PropTypes.array,
  setIsOpenLiveTrendPage: PropTypes.func,
  setIsDrawerOpen: PropTypes.func,
  setEditingLiveTrendChart: PropTypes.func,
};
